import { GetterTree } from 'vuex';
import { ForexTemplateState } from './interface';
import { IStoreRootState } from '@/store/interface';
import { ForexTemplateGetter } from '@/feature/TrHistory/store/template/constants';

export default <GetterTree<ForexTemplateState, IStoreRootState>> {

	[ForexTemplateGetter.list]: ({ list }): ForexTemplateState['list'] => list,

	[ForexTemplateGetter.loading]: ({ loadingCount }) => loadingCount !== 0,

	[ForexTemplateGetter.currentTemplate]: ({ currentTemplate }) => currentTemplate,

}
